export const Action = Object.freeze({
    InternalLink: 'internal_link',
    ExternalLink: 'external_link',
    StartWebForm: 'start_web_form',
    TriggerDialer: 'trigger_dialer',
    ThunderboltLink: 'thunderbolt_link',
})
